import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Spinner');

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    loading: PropTypes.bool,
};

const defaultProps = {
    loading: true,
};

function Spinner(props) {
    const { className, loading, children } = props;

    return (
        <div className={bem(null, null, className)}>
            <div className={bem('layer', { loading, fixed: children && loading })} />
            {children}
        </div>
    );
}

Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;

export default Spinner;
